import React, { useState } from 'react';
import moment from 'moment';
import { QueryTableResponse } from 'global';
import { useQuery } from '@apollo/client';
import { DateFormats } from 'constants/common';
import { Listing } from 'components/shared/TableListing';

import { ProductChangeLogTableRow } from '../../types';
import { configurationListingColumns } from './listingConfig';
import { aftermarketProductsApi, GetProductChangelogVariables, ChangelogItem } from '../../api';

interface ChangelogTableProps {
  productId: string;
}

export const ChangelogListing = ({ productId }: ChangelogTableProps) => {
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 });

  const { data, previousData, loading } = useQuery<QueryTableResponse<ChangelogItem>, GetProductChangelogVariables>(
    aftermarketProductsApi.changelog.getProductChangelog,
    {
      variables: {
        input: {
          productId,
          pagination,
        },
      },
    }
  );

  const tableData = (data?.result?.items ?? previousData?.result?.items ?? []).map(log => ({
    id: log.id,
    changes: log.changes,
    changeType: log.changeType,
    modifiedBy: log.modifiedBy.fullName,
    createdDateTime: moment(log.createdDateTime).format(DateFormats.DateTimeMedium24Hour),
  }));

  return (
    <Listing<ProductChangeLogTableRow>
      loading={loading}
      tableData={tableData}
      columns={configurationListingColumns}
      pagination={{
        ...pagination,
        total: data?.result?.pagination?.total ?? 0,
        onChange: nextValue => setPagination(prev => ({ ...prev, page: nextValue })),
      }}
    />
  );
};
